export default __webpack_public_path__ + "static/media/cow.e1da7849.png";